module.exports = __webpack_public_path__ + "static/media/2_3.8a2e6acf.png";